import Radium from '@flipdish/radium';
import * as React from 'react';
import * as Api from '../../Api';
const tinycolor = require('tinycolor2');

interface Props {
  OnClick: () => any;
  Message: string;
  Disabled: boolean;
  RightArrow: boolean;
  AppDesignScheme: Api.AppDesignScheme;
}

interface State {}

export class BottomBarConfigure extends React.Component<Props, State> {
  public render(): JSX.Element | null {
    const {
      AppDesignScheme,
      RightArrow,
      OnClick,
      Disabled,
      Message
    } = this.props;

    const rightArrow = RightArrow ? <span>&rarr;</span> : null;

    const styles = {
      primary: {
        color: AppDesignScheme.Primary
      },
      buttonSecondary: {
        backgroundColor: AppDesignScheme.Secondary,
        ':hover': {},
        ':active': {},
        ':focus': {}
      },
      buttonActive: {
        backgroundColor: tinycolor(AppDesignScheme.Secondary)
          .darken(10)
          .toString()
      },
      buttonHover: {
        backgroundColor: tinycolor(AppDesignScheme.Secondary)
          .darken(5)
          .toString()
      }
    };

    return (
      <button
        className={`fd-button fd-button--bottom fd-button--secondary visible-xs-block visible-sm-block fd-button--bottom-ios`}
        onClick={OnClick}
        disabled={Disabled}
        key="done-button-bottom"
        style={
          [
            styles.buttonSecondary,
            Radium.getState(this.state, 'done-button-bottom', ':active')
              ? styles.buttonActive
              : Radium.getState(this.state, 'done-button-bottom', ':hover')
              ? styles.buttonHover
              : null
          ] as any
        }
      >
        <h3 className="clear-margins primary" style={styles.primary}>
          {Message}
          {rightArrow}
        </h3>
      </button>
    );
  }
}

export default Radium(BottomBarConfigure);
